import { useGetUserQuery } from '@/services/ApiService.ts';
import { getCookie } from '@/lib/utils';

const LOGIN_PATHS = ['/login-demo', '/login'];

export const useUser = () => {
    // No window during a server render; a server render is never on a login path (those routes
    // are not server-rendered) and never has a session, so the query is skipped either way.
    const isLoginPath = typeof window !== 'undefined'
        && LOGIN_PATHS.some(p => window.location.pathname === p);
    const { data, isFetching, isLoading, isError, isUninitialized } = useGetUserQuery(undefined, {
        skip: getCookie('sessioncache') === null || isLoginPath,
    });

    return {
        user: data,
        isFetching,
        // The first load only. `isFetching` is true again for a session refresh or a profile save,
        // both of which invalidate this query.
        isLoading,
        isError,
        isUninitialized,
    };
};
